<div class="p-grid">
    <div class="p-col-12">
        <app-filter [filterByInput]="cols" [filterByInputValue]="filterByInputValue"
            (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
            (onApplyFilter)="onApplyFilter(selectedWindow, $event)" (onModifyFilterOptions)="onModifyFilterOptions(selectedWindow, $event)" 
            (onChangeRange)="onChangeRange(selectedWindow, $event)" [showChannelFilter]="true" [showModuleFilter]="true">
        </app-filter>
    </div>

    <div class="p-col-12">
        <div class="card">
            <div class="main-content">
                <div *ngIf="selectedWindow==='userActivityByUsers' 
                    || selectedWindow==='userActivityByDate' 
                    || selectedWindow==='userActivityByActivityType'  " id="divLeadsReport">
                    <div class="p-d-flex p-jc-between">
                        <h5>{{reportName}}</h5>
                        <h4>{{organizationName}}</h4>
                        <h5>{{ dateFrom | date: 'MM/dd/yyyy'}} - {{ dateTo | date:'MM/dd/yyyy'}} </h5>
                    </div>
                    
                    <p-table #loginReportsTabel [columns]="cols" [value]="reportsData" [scrollable]="true"
                    [style]="{width:'100%'}" [(rows)]="showRows"
                    [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [paginator]="true" selectionMode="single"
                    [(first)]="first">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <ng-container *ngFor="let col of columns; let i = index;">
                                    <th *ngIf="col.field !== 'comment'">
                                        {{col.header}}
                                    </th>
                                    <th *ngIf="col.field == 'comment'" style="min-width: 300px;">
                                        {{col.header}}
                                    </th>
                                </ng-container>
                            </tr>
                        </ng-template>
    
                        <ng-template pTemplate="body" let-index="rowIndex" let-rowData let-columns="columns">
                            <tr *ngIf="index>0 ? (reportsData[index-1].userName!=rowData.userName || index%loginReportsTabel.rows==0): true" class="parentRow">
                                <td [colspan]="columns.length">{{rowData.userName}}</td>
                            </tr>
                            <tr>
                                <ng-container *ngFor="let col of columns; let i = index;">
                                    <td *ngIf="col.field == 'comment'" style="min-width: 300px;">
    
                                        <ng-container  [ngSwitch]="col.dataType">
                                            <ng-container *ngSwitchCase="'datetime'">
                                                {{ rowData[col.field] | localDate }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                <div>{{rowData[col.field]}}</div>
                                            </ng-container>
                                        </ng-container>
    
                                    </td>
                                    <td *ngIf="col.field !== 'comment'">
                                        <ng-container  [ngSwitch]="col.dataType">
                                            <ng-container *ngSwitchCase="'datetime'">
                                                {{ rowData[col.field] | localDate }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                <div>{{rowData[col.field]}}</div>
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
    
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="18">{{noContactFindOrLoadingText}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
    
</div>